
import { Inject } from "vue-property-decorator"
import { Options, Vue } from "vue-class-component"
import draggable from "vuedraggable"
@Options({
  name: "element-panel",
  props: ["element"],
  components: { draggable }
})
export default class Element extends Vue {
  @Inject() config!: any
  search: string = ""
  readonly element: any[] = []

  get group(): any {
    const map: any = {}
    for (const index in this.element) {
      const element = this.element[index]
      const item = (map[element.group] = map[element.group] || [])
      item.push(element)
    }
    return map
  }

  onSearch(search: any) {
    this.search = search.value
    search.focus()
  }

  onMove(other: number, evt: any) {
    const classname: string = "moving"
    switch (other) {
      case 1:
        evt.from.classList.add(classname)
        break
      case 2:
        evt.from.classList.remove(classname)
        break
      case 3:
        const { condition } = this.config
        const element = evt.draggedContext.element
        if (!condition.root) return true
        else if (!evt.to.hasAttribute("data-box")) {
          return condition.root.includes(element.el)
        } else {
          const condi = condition[evt.to.getAttribute("data-box")]
          if (!condi) return true
          else return condi.includes(element.el)
        }
    }
  }
}
